/**
 * Safe YYYY-MM-DD ↔ Date helpers.
 *
 * new Date("2026-02-28") parses as UTC midnight, which shifts when displayed
 * in western timezones (Feb 28 UTC → Feb 27 PST). These helpers avoid that
 * by using the Date(year, month, day) constructor which creates local midnight.
 */

export const toDateString = (date) => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

export const fromDateString = (str) => {
  if (!str) return null;
  const dateOnly = str.split("T")[0];
  const [y, m, d] = dateOnly.split("-").map(Number);
  return new Date(y, m - 1, d);
};
